var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgermen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E7EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 42.5263C25.1333 42.5263 24 41.393 24 39.9999C24 38.6069 25.1333 37.4736 26.5263 37.4736H53.4737C54.8668 37.4736 56 38.6069 56 39.9999C56 41.393 54.8668 42.5263 53.4737 42.5263H26.5263Z",
    fill: "#395B9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 30.7372C25.1333 30.7372 24 29.604 24 28.2109C24 26.8178 25.1333 25.6846 26.5263 25.6846H53.4737C54.8668 25.6846 56 26.8178 56 28.2109C56 29.6039 54.8668 30.7372 53.4737 30.7372H26.5263Z",
    fill: "#395B9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 54.3163C25.1333 54.3163 24 53.183 24 51.79C24 50.3969 25.1333 49.2637 26.5263 49.2637H53.4737C54.8668 49.2637 56 50.3969 56 51.79C56 53.183 54.8668 54.3163 53.4737 54.3163H26.5263Z",
    fill: "#395B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgermen);
export default __webpack_public_path__ + "static/media/hamburgermen.b60c42506be020e17f07b07c31c58645.svg";
export { ForwardRef as ReactComponent };